import axios from "../helpers/bearerAxios";
import { logger } from "./loggingService";

export const getTMY3WeatherCSVFile = async (filename: string) => {
    return await axios.get(`${import.meta.env.VITE_BASE_URL}${import.meta.env.VITE_FETCH_TMY3_CSV_URL}?filename=${filename}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            logger.error(error);
            return error;
        })
}

